import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {IMAGE_URL} from "../path";
import { getNewsStories } from "../actions/ApiCalls";

function NewsStories() {
    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    const navigate = useNavigate();
    const [newsStories, setNewsStories] = useState<any[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const articlesPerPage = 12;
    const imgUrl = IMAGE_URL;

    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        isDesktop: window.innerWidth > 950,
        isTablet: window.innerWidth <= 950 && window.innerWidth > 575,
        isMobile: window.innerWidth <= 575
    });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [currentPage]);

    useEffect(() => {
        fetchNewsStories(currentPage);
        document.title = "Vinimark | News";
    }, [currentPage]);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setScreenSize({
                width,
                isDesktop: width > 950,
                isTablet: width <= 950 && width > 575,
                isMobile: width <= 575
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function fetchNewsStories(page: number) {
        getNewsStories(page, articlesPerPage)
            .then(response => {
                setNewsStories(response.data.data);
                setTotalPages(response.data.last_page);
            })
            .catch(error => {
                console.error("Failed to fetch news stories:", error);
            });
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
        }}>
            <Header />
            <div style={{
                marginTop: '130px',
                display: "flex",
                flexDirection: screenSize.isMobile ? 'column' : 'row',
                gap: '20px'
            }}>
                <div style={{ flex: 1 }}></div>
                <div style={{
                    flex: 1,
                    textAlign: 'left',
                    paddingRight: '20px',
                    paddingLeft: screenSize.isMobile ? '20px' : '50px'
                }}>
                    <p style={{ fontWeight: 600 }}>STORIES</p>
                    <p style={{
                        width: screenSize.isMobile ? '95%' : '60%',
                        marginBottom: '10px',
                        fontWeight: 400
                    }}>
                        Every bottle of wine carries a story—of the land, the people, and the moments it creates. Here, we share ours. From exciting announcements and team milestones to industry insights and celebrated events, this is where our journey unfolds. Stay connected, be inspired, and raise a glass with us as we shape the future of wine, one story at a time.
                    </p>
                    <p style={{ fontSize: '13px', marginBottom: '100px' }}>
                        <a style={linkStyle} href="/subscribe">Join our mailing list</a>
                    </p>
                </div>
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: screenSize.isDesktop
                    ? 'repeat(4, 1fr)'
                    : screenSize.isTablet
                        ? 'repeat(2, 1fr)'
                        : '1fr',
                gap: screenSize.isMobile ? '25px' : '40px',
                padding: screenSize.isMobile
                    ? '0'
                    : screenSize.isTablet
                        ? '0 30px'
                        : '0 50px',
                marginBottom: '50px'
            }}>
                {newsStories.map((article, index) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: screenSize.isMobile ? 'center' : 'flex-start',
                            marginBottom: screenSize.isMobile ? '25px' : '40px',
                            width: '100%',
                        }}
                    >
                        <div style={{
                            width: screenSize.isMobile ? '100vw' : '100%',
                            aspectRatio: '16/9',
                            overflow: 'hidden',
                            marginBottom: '20px',
                            position: screenSize.isMobile ? 'relative' : 'static',
                            left: screenSize.isMobile ? '50%' : '0',
                            transform: screenSize.isMobile ? 'translateX(-50%)' : 'none',
                        }}>
                            <img
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                }}
                                src={imgUrl + article.image_path}
                                alt={article.title}
                            />
                        </div>

                        <div style={{
                            width: screenSize.isMobile ? '90%' : '100%',
                            textAlign: 'left',
                        }}>
                            <p style={{
                                fontSize: '13px',
                                fontWeight: 600,
                                marginTop: 0,
                                textTransform: 'uppercase',
                                marginBottom: '8px',
                            }}>
                                {article.title}
                            </p>
                            <p style={{
                                fontSize: '10px',
                                fontWeight: 600,
                                marginBottom: '12px'
                            }}>
                                {article.year_posted}
                            </p>
                            <div style={{
                                marginBottom: '15px',
                                fontWeight: 400,
                                fontSize: '12px'
                            }}>
                                {article.subtitle}
                            </div>
                            <a
                                style={linkStyle}
                                onClick={() => navigate(`/news/${article.search_title}`, {
                                    state: { article },
                                })}
                            >
                                Read more
                            </a>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <a
                    style={{
                        ...linkStyle,
                        display: 'block',
                        width: '100%',
                        textAlign: 'center',
                        paddingTop: '50px',
                        paddingBottom: '30px',
                    }}
                    href={'/subscribe'}
                >
                    Join our newsletter
                </a>
            </div>

            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '50px',
                gap: '20px'
            }}>
                <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    style={{minWidth: '100px', textAlign: "center"}}
                >
                    Previous
                </button>
                <span style={{ minWidth: '100px', textAlign: 'center' }}>
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    style={{minWidth: '100px', textAlign: 'center'}}
                >
                    Next
                </button>
            </div>
            <Footer />
        </div>
    );
}

export default NewsStories;
